import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import { GiftCardProductVariant } from '../../../../../types';
import { GiftCardController } from './controller/GiftCardController';
import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import { SEO_PAGE_NAMES, SPECS } from '../../consts';

const Controller: CreateControllerFn = async (controllerParams) => {
  const controller = await GiftCardController(controllerParams);

  controllerParams.controllerConfig.setProps({ fitToContentHeight: true });

  const shouldCallBreadcrumbsSEO = controllerParams.flowAPI.experiments.enabled(
    SPECS.BreadcrumbsSEOProgram,
  );

  return {
    pageReady: async () => {
      await controller.init();

      const product = controller.getProduct();
      const wixCodeApi = controllerParams.flowAPI.controllerConfig.wixCodeApi;
      const currency = wixCodeApi.site.currency;

      const presetPrices = (product?.variants || [])
        .filter((variant) => variant.type === 'preset' && variant.active)
        .map((variant) => (variant as GiftCardProductVariant).price);

      const giftCardData = {
        pageUrl: `${wixCodeApi.location.baseUrl}/${wixCodeApi.location.path}`,
        cardName: product?.name,
        cardDesc: product?.description,
        image: [
          {
            imageWidth: product?.media.width,
            imageHeight: product?.media.height,
            imageUrl: product?.media.url,
            imageAlt: product?.media.alt_image,
          },
        ],
        price: {
          price: presetPrices,
          priceCurrency: currency,
        },
      };
      await wixCodeApi.seo.renderSEOTags({
        itemType: ITEM_TYPES.GIFT_CARD,
        itemData: {
          giftCard: giftCardData,
        },
      });

      if (shouldCallBreadcrumbsSEO) {
        const { baseUrl } = wixCodeApi.location;
        const path = wixCodeApi.location.path[0];
        const breadcrumbsData = [
          {
            name: SEO_PAGE_NAMES.Home,
            item: baseUrl,
          },
          {
            name: SEO_PAGE_NAMES.GiftCard,
            item: `${baseUrl}/${path}`,
          },
        ];
        await wixCodeApi.seo.renderSEOTags({
          itemType: ITEM_TYPES.BREADCRUMBS_COMPONENT,
          itemData: { items: breadcrumbsData },
        });
      }
    },
    exports: () => controller.exports(),
  };
};

export default Controller;
